<template>
  <div class="workflow-setting-page">
    <div class="figma-white-card">
      <!-- 页面标题栏：面包屑 + 返回按钮 -->
      <div class="figma-page-header">
        <div class="figma-breadcrumb">
          <span class="breadcrumb-parent">{{ $t('workflowSettingManage.breadcrumb.parent') }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-current">{{ $t('workflowSettingManage.breadcrumb.current') }}</span>
        </div>
        <el-button size="small" class="figma-btn-back" @click="_goBack">
          <i class="el-icon-arrow-left"></i>{{ $t('workflowSettingManage.action.back') }}
        </el-button>
      </div>

      <!-- 流程信息表单 -->
      <div class="figma-form-section">
        <el-form label-width="120px" class="figma-form">
          <div class="figma-form-row">
            <el-form-item :label="$t('workflowSettingManage.flowName')">
              <el-input
                v-model="workflowSettingInfo.flowName"
                size="small"
                :placeholder="$t('workflowSettingManage.flowNamePlaceholder')"
                class="figma-form-input"
                disabled
              />
            </el-form-item>
          </div>
          <div class="figma-form-row">
            <el-form-item :label="$t('workflowSettingManage.description')">
              <el-input
                v-model="workflowSettingInfo.describle"
                type="textarea"
                size="small"
                :placeholder="$t('workflowSettingManage.descriptionPlaceholder')"
                :rows="3"
                class="figma-form-input"
              />
            </el-form-item>
          </div>
          <div class="figma-form-row">
            <el-form-item :label="$t('workflowSettingManage.submitterEnd')">
              <el-select
                v-model="workflowSettingInfo.startNodeFinish"
                size="small"
                :placeholder="$t('workflowSettingManage.submitterEndPlaceholder')"
                class="figma-form-input"
              >
                <el-option :label="$t('workflowSettingManage.yes')" value="Y" />
                <el-option :label="$t('workflowSettingManage.no')" value="N" />
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>

      <!-- 流程步骤区域 -->
      <div class="figma-steps-section">
        <div class="figma-steps-header">
          <span class="steps-title">{{ $t('workflowSettingManage.flowSteps') }}</span>
          <el-button size="small" class="figma-btn-add-step" @click="addWorkflowStep">
            <i class="el-icon-plus"></i>
            <span>{{ $t('workflowSettingManage.addStep') }}</span>
          </el-button>
        </div>

        <div class="figma-steps-list">
          <div
            v-for="(item, index) in workflowSettingInfo.steps"
            :key="index"
            class="figma-step-card"
          >
            <div class="step-card-header">
              <span class="step-number">{{ $t('workflowSettingManage.step') }} {{ index + 1 }}</span>
              <div class="step-actions">
                <a class="step-link step-link-blue" @click="chooseStaff(item)">
                  {{ item.staffId ? item.staffName : $t('workflowSettingManage.selectStaff') }}
                </a>
                <div class="step-type-radios">
                  <label class="figma-radio">
                    <input
                      type="radio"
                      :name="`step-type-${index}`"
                      value="2"
                      v-model="item.type"
                      @change="chooseType(item)"
                    />
                    <span class="radio-label">{{ $t('workflowSettingManage.normalFlow') }}</span>
                  </label>
                  <label class="figma-radio" v-if="index !== 0">
                    <input
                      type="radio"
                      :name="`step-type-${index}`"
                      value="1"
                      v-model="item.type"
                      @change="chooseType(item)"
                    />
                    <span class="radio-label">{{ $t('workflowSettingManage.countersign') }}</span>
                  </label>
                </div>
                <a class="step-link step-link-red" @click="deleteStep(item)">
                  {{ $t('workflowSettingManage.deleteStep') }}
                </a>
                <el-button
                  v-if="item.type == 1"
                  size="mini"
                  class="figma-btn-add-staff"
                  @click="addStaff(item)"
                >
                  {{ $t('workflowSettingManage.addStaff') }}
                </el-button>
              </div>
            </div>

            <!-- 会签子人员 -->
            <div v-for="(subItem, subIndex) in item.subStaff" :key="subIndex" class="figma-sub-staff">
              <a class="step-link step-link-blue" @click="chooseStaff(subItem)">
                {{ subItem.staffId ? subItem.staffName : $t('workflowSettingManage.selectStaff') }}
              </a>
              <a class="step-link step-link-red" @click="deleteStaff(item, subItem)">
                {{ $t('workflowSettingManage.deleteStaff') }}
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="figma-form-actions">
        <el-button size="small" class="figma-btn-submit" @click="saveWorkflowSettingInfo">
          {{ $t('workflowSettingManage.submit') }}
        </el-button>
        <el-button size="small" class="figma-btn-cancel" @click="_goBack">
          {{ $t('workflowSettingManage.cancel') }}
        </el-button>
      </div>

      <!-- 说明区域 -->
      <div class="figma-instructions" v-if="workflowSettingInfo.flowType === '70007'">
        <div class="instructions-title">{{ $t('workflowSettingManage.instructions') }}</div>
        <div class="instructions-content">
          <p>1. {{ $t('workflowSettingManage.instruction1') }}</p>
          <p>2. {{ $t('workflowSettingManage.instruction2') }}</p>
          <p>3. {{ $t('workflowSettingManage.instruction3') }}</p>
          <p>4. {{ $t('workflowSettingManage.instruction4') }}</p>
        </div>
      </div>
    </div>

    <select-staff ref="selectStaff" @selectStaff="handleStaffSelected" />
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import SelectStaff from '@/components/staff/SelectStaff'
import {
  getWorkflowSteps,
  updateWorkflow
} from '@/api/system/workflowSettingManageApi'

export default {
  name: 'WorkflowSettingManageList',
  components: {
    SelectStaff
  },
  data() {
    return {
      communityId: '',
      workflowSettingInfo: {
        flowId: '',
        flowName: '',
        flowType: '',
        describle: '',
        startNodeFinish: 'Y',
        steps: []
      },
      currentSelectTarget: null
    }
  },
  created() {
    this.communityId = getCommunityId()
    this._initWorkflowSettingInfo()
  },
  methods: {
    generateId() {
      return `id-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`
    },

    async _initWorkflowSettingInfo() {
      const flowId = this.$route.query.flowId

      if (!flowId) {
        this.$message.error(this.$t('workflowSettingManage.invalidOperation'))
        this.$router.go(-1)
        return
      }

      this.workflowSettingInfo.flowId = flowId
      this.workflowSettingInfo.flowName = this.$route.query.flowName
      this.workflowSettingInfo.flowType = this.$route.query.flowType
      this.workflowSettingInfo.startNodeFinish = this.$route.query.startNodeFinish || 'Y'

      try {
        const { data } = await getWorkflowSteps({
          communityId: this.communityId,
          flowId
        })
        this._freshResStep(data)
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    _freshResStep(data) {
      if (!data) {
        this.workflowSettingInfo.steps = []
        return
      }

      this.workflowSettingInfo.describle = data.describle || ''
      if (data.startNodeFinish) {
        this.workflowSettingInfo.startNodeFinish = data.startNodeFinish
      }

      const workflowSteps = Array.isArray(data.workflowSteps) ? data.workflowSteps : []
      const steps = workflowSteps.map((step, index) => {
        const staffList = Array.isArray(step.workflowStepStaffs) ? step.workflowStepStaffs : []
        const mainStaff = staffList[0] || {}

        const subStaff = staffList.slice(1).map(staff => ({
          id: staff.id || this.generateId(),
          staffId: staff.staffId || staff.userId || '',
          staffName: staff.staffName || staff.userName || staff.name || '',
          staffRole: staff.staffRole || ''
        }))

        return {
          seq: index,
          staffId: mainStaff.staffId || mainStaff.userId || '',
          staffName: mainStaff.staffName || mainStaff.userName || mainStaff.name || '',
          staffRole: mainStaff.staffRole || '',
          type: String(step.type || '2'),
          subStaff
        }
      })

      this.workflowSettingInfo.steps = steps
    },

    addWorkflowStep() {
      const step = {
        seq: this.workflowSettingInfo.steps.length,
        staffId: '',
        staffName: '',
        type: '2',
        subStaff: []
      }
      this.workflowSettingInfo.steps.push(step)
    },

    chooseStaff(item) {
      item.from = this._getStaffFromType()
      this.currentSelectTarget = item
      this.$refs.selectStaff.open()
    },

    _getStaffFromType() {
      const type = this.workflowSettingInfo.flowType
      if (['30003', '40004', '70007', '80008'].includes(type)) {
        return 'purchase'
      }
      if (['50005', '60006'].includes(type)) {
        return 'contract'
      }
      return ''
    },

    _goBack() {
      this.$router.go(-1)
    },

    deleteStep(step) {
      this.workflowSettingInfo.steps = this.workflowSettingInfo.steps.filter(
        s => s.seq !== step.seq
      )
    },

    addStaff(step) {
      step.subStaff.push({
        id: this.generateId(),
        staffId: '',
        staffName: '',
        staffRole: '1001'
      })
    },

    deleteStaff(step, subStaff) {
      step.subStaff = step.subStaff.filter(s => s.id !== subStaff.id)
    },

    chooseType(item) {
      if (item.type === '1') {
        item.subStaff = []
      }
    },

    handleStaffSelected(staff) {
      if (!this.currentSelectTarget) {
        return
      }
      const target = this.currentSelectTarget
      this.$set(target, 'staffId', staff.staffId || staff.userId || '')
      this.$set(target, 'staffName', staff.staffName || staff.userName || staff.name || '')
      if (staff.staffRole) {
        this.$set(target, 'staffRole', staff.staffRole)
      }
      this.currentSelectTarget = null
    },

    async saveWorkflowSettingInfo() {
      try {
        await updateWorkflow({
          ...this.workflowSettingInfo,
          communityId: this.communityId
        })
        this.$message.success(this.$t('workflowSettingManage.saveSuccess'))
        this._goBack()
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>

<style scoped>
.workflow-setting-page {
  height: calc(100vh - 60px);
  background: #EBF2FA;
  padding: 0;
  overflow: auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.figma-white-card {
  background: white;
  border-radius: 0 0 12px 12px;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 20px 24px;
}

/* 页面标题栏 */
.figma-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: 1px solid #EBF2FA;
  flex-shrink: 0;
}

.figma-breadcrumb {
  display: flex;
  align-items: center;
  gap: 4px;
}

.breadcrumb-parent {
  font-size: 16px;
  font-weight: 600;
  color: #8C9BB4;
  font-family: 'PingFang SC';
  line-height: 22px;
}

.breadcrumb-separator {
  font-size: 16px;
  font-weight: 600;
  color: #8C9BB4;
  font-family: 'PingFang SC';
  line-height: 22px;
  margin: 0 4px;
}

.breadcrumb-current {
  font-size: 16px;
  font-weight: 600;
  color: #1D2129;
  font-family: 'PingFang SC';
  line-height: 22px;
}

.figma-btn-back {
  width: 78px;
  height: 38px;
  border-radius: 10px !important;
  border: 1px #0E76FF solid !important;
  background: white !important;
  color: #0E76FF !important;
  font-size: 14px;
  font-weight: 500;
  font-family: 'PingFang SC';
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.figma-btn-back i {
  margin-right: 4px;
}

.figma-btn-back:hover {
  background: rgba(14, 118, 255, 0.08) !important;
}

/* 表单区域 */
.figma-form-section {
  padding: 24px 0 0;
  flex-shrink: 0;
}

.figma-form >>> .el-form-item {
  margin-bottom: 16px;
}

.figma-form >>> .el-form-item__label {
  color: #1D2129;
  font-size: 14px;
  font-family: 'PingFang SC';
  font-weight: 400;
}

.figma-form-input {
  width: 100%;
  max-width: 600px;
}

.figma-form-input >>> .el-input__inner {
  border-radius: 10px;
  border: none;
  outline: 1px #DCE6F5 solid;
  outline-offset: -1px;
  height: 38px;
  font-size: 14px;
  background: white;
  color: #1D2129;
}

.figma-form-input >>> .el-input__inner:focus {
  outline-color: #0E76FF;
}

.figma-form-input >>> .el-input__inner::placeholder {
  color: #8C9BB4;
  font-family: 'Inter', 'PingFang SC';
}

.figma-form-input >>> .el-textarea__inner {
  border-radius: 10px;
  border: none;
  outline: 1px #DCE6F5 solid;
  outline-offset: -1px;
  font-size: 14px;
  background: white;
  color: #1D2129;
  padding: 10px 16px;
}

.figma-form-input >>> .el-textarea__inner:focus {
  outline-color: #0E76FF;
}

.figma-form-input >>> .el-textarea__inner::placeholder {
  color: #8C9BB4;
  font-family: 'Inter', 'PingFang SC';
}

.figma-form-input >>> .el-select .el-input__inner {
  padding-right: 30px;
}

/* 流程步骤区域 */
.figma-steps-section {
  padding: 24px 0 0;
  flex: 1;
  min-height: 0;
}

.figma-steps-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.steps-title {
  font-size: 16px;
  font-weight: 600;
  color: #1D2129;
  font-family: 'PingFang SC';
}

.figma-btn-add-step {
  height: 38px;
  border-radius: 10px !important;
  background: #0E76FF !important;
  border: none !important;
  color: white !important;
  font-size: 14px;
  font-weight: 500;
  font-family: 'PingFang SC';
  padding: 0 16px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.figma-btn-add-step:hover {
  background: #1C99FF !important;
}

.figma-steps-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: auto;
  max-height: 400px;
  padding-right: 4px;
}

/* 步骤卡片 */
.figma-step-card {
  background: #F8FBFF;
  border-radius: 12px;
  border: 1px solid #DCE6F5;
  padding: 16px 20px;
}

.step-card-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.step-number {
  font-size: 14px;
  font-weight: 600;
  color: #0E76FF;
  font-family: 'PingFang SC';
  background: #E8F3FF;
  padding: 4px 12px;
  border-radius: 8px;
}

.step-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.step-link {
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  font-weight: 400;
  font-family: 'PingFang SC';
}

.step-link:hover {
  opacity: 0.85;
}

.step-link-blue {
  color: #0E76FF;
}

.step-link-red {
  color: #FB2C36;
}

.step-type-radios {
  display: flex;
  align-items: center;
  gap: 12px;
}

.figma-radio {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: 14px;
  color: #1D2129;
  font-family: 'PingFang SC';
}

.figma-radio input[type="radio"] {
  accent-color: #0E76FF;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.radio-label {
  font-size: 14px;
  color: #1D2129;
}

.figma-btn-add-staff {
  height: 28px;
  border-radius: 8px !important;
  background: rgba(14, 118, 255, 0.08) !important;
  border: 1px #0E76FF solid !important;
  color: #0E76FF !important;
  font-size: 13px;
  font-weight: 400;
  font-family: 'PingFang SC';
  padding: 0 10px;
}

.figma-btn-add-staff:hover {
  background: rgba(14, 118, 255, 0.15) !important;
}

/* 子人员 */
.figma-sub-staff {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 10px;
  margin-left: 80px;
  padding: 8px 16px;
  background: white;
  border-radius: 8px;
  border: 1px solid #EBF2FA;
}

/* 操作按钮 */
.figma-form-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 24px 0 16px;
  gap: 12px;
  flex-shrink: 0;
}

.figma-btn-submit {
  width: 98px;
  height: 38px;
  border-radius: 10px !important;
  background: #0E76FF !important;
  border: none !important;
  color: white !important;
  font-size: 14px;
  font-weight: 500;
  font-family: 'PingFang SC';
  padding: 0;
}

.figma-btn-submit:hover {
  background: #1C99FF !important;
}

.figma-btn-cancel {
  width: 98px;
  height: 38px;
  border-radius: 10px !important;
  border: 1px #0E76FF solid !important;
  background: white !important;
  color: #0E76FF !important;
  font-size: 14px;
  font-weight: 500;
  font-family: 'PingFang SC';
  padding: 0;
}

.figma-btn-cancel:hover {
  background: rgba(14, 118, 255, 0.08) !important;
}

/* 说明区域 */
.figma-instructions {
  background: #F8FBFF;
  border-radius: 12px;
  border: 1px solid #DCE6F5;
  padding: 16px 20px;
  flex-shrink: 0;
}

.instructions-title {
  font-size: 16px;
  font-weight: 600;
  color: #1D2129;
  font-family: 'PingFang SC';
  margin-bottom: 8px;
}

.instructions-content p {
  font-size: 14px;
  color: #364153;
  font-family: 'PingFang SC';
  line-height: 24px;
  margin: 0;
}

@media (max-width: 1024px) {
  .figma-page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  .step-card-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .step-actions {
    flex-wrap: wrap;
  }
}
</style>
